module.exports = __webpack_public_path__ + "static/img/about-citys.e8cf7fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/about-citys.jpg
// module id = VbuQ
// module chunks = 0